import gql from 'graphql-tag';

export const GET_MERCHANT_OFFERS_RESULTS = gql`
  query OfferById($params: OfferFindByInput!) {
    offerFindBy(params: $params) {
      offers {
        offerUuid
        offerName
        offerSchedule {
          startDate
          endDate
        }
        offerDescription
        offerStartDate
        offerEndDate
        offerVisible
        offerDraft
        offerDeleted
        offerKeywords
        paymentNetworkMCC
        paymentNetworkMCCDescription
        merchantServiceCampaignUuid
        hasOnlineLocations
        hasNearbyLocations
        exactSpendToActivate
        segments {
          uuid
          cashbackAmount
          cashbackDailyLimit
          cashbackPercentage
          segmentType
          segmentPriority
          startDate
          endDate
          offerTitleOverride
          hideOfferForSegment
          minSpendToActivate
          exactSpendToActivate
          baseCashbackAmount
          baseCashbackPercentage
          promotionType
          targetingRules {
            type
            data
            dataByKey
          }
          marketplaces
        }
      }
    }
  }
`;

export default GET_MERCHANT_OFFERS_RESULTS;
